import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Job13y4jkazwjho0 as Job,
  Key_instance2tirv2rj82ml4 as Key_instance,
  ensureActive2yo7199srjlgl as ensureActive,
} from './Job.mjs';
import {
  ContextScoper0znlsj7ufhq as ContextScope,
  ScopeCoroutine2c07fgm3ekmnx as ScopeCoroutine,
} from './internal/Scopes.mjs';
import { startUndispatchedOrReturn1od7ryhr362dr as startUndispatchedOrReturn } from './intrinsics/Undispatched.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CoroutineScopeClass;
function CoroutineScope() {
  if (CoroutineScopeClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'CoroutineScope');
    CoroutineScopeClass = $;
  }
  return CoroutineScopeClass;
}
function CoroutineScope_0(context) {
  return new (ContextScope())(!(context.cd(Key_instance) == null) ? context : context.gp(Job()));
}
function ensureActive_0(_this__u8e3s4) {
  return ensureActive(_this__u8e3s4.ea2());
}
function coroutineScope(block, $completion) {
  var coroutine = new (ScopeCoroutine())($completion.pc(), $completion);
  return startUndispatchedOrReturn(coroutine, coroutine, block);
}
function cancel(_this__u8e3s4, cause) {
  cause = cause === VOID ? null : cause;
  var tmp0_elvis_lhs = _this__u8e3s4.ea2().cd(Key_instance);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var message = 'Scope cannot be cancelled because it does not have a job: ' + toString(_this__u8e3s4);
    throw IllegalStateException().o4(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var job = tmp;
  job.la3(cause);
}
function plus(_this__u8e3s4, context) {
  return new (ContextScope())(_this__u8e3s4.ea2().gp(context));
}
//region block: exports
export {
  coroutineScope as coroutineScope284yy3flyb2v2,
  CoroutineScope_0 as CoroutineScopelux7s7zphw7e,
  CoroutineScope as CoroutineScopefcb5f5dwqcas,
  cancel as cancel36mj9lv3a0whl,
  ensureActive_0 as ensureActivem48bojk66pw0,
  plus as plusypd30qeai057,
};
//endregion

//# sourceMappingURL=CoroutineScope.mjs.map
